/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserIdentityModel } from '../../models/user-identity-model';

export interface UserPost$Params {
      body?: UserIdentityModel
}

export function userPost(http: HttpClient, rootUrl: string, params?: UserPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, userPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<string>;
    })
  );
}

userPost.PATH = '/User';
